import React from 'react'
import { Form, FormGroup, Label, Input, Button, Modal, ModalBody, ModalHeader, FormFeedback } from 'reactstrap'
import * as Yup from "yup"
import { useFormik } from "formik"
import { useDispatch } from 'react-redux'
import { updateIncomeRange } from 'store/actions'

const UpdateIncomeRange = ({modal, setModal}) => {

    const dispatch = useDispatch();

    const handleCloseModal = () => {
        setModal({ ...modal, isShow: false })
    }
    const validation = useFormik({
        // enableReinitialize : use this  flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            range_from: modal.range_from || "",
            range_to: modal.range_to || "",
        },
        validationSchema: Yup.object({
            range_from: Yup.string().required("Please Enter Range (From)"),
            range_to: Yup.string().required("Please Enter Range (To)"),
        }),
        onSubmit: values => {
       //     dispatch(addNewRto(values))
                const IncomeLable = `${values.range_from} To ${values.range_to}`
                dispatch(updateIncomeRange({
                    id: modal.id,
                    label: IncomeLable,
                    range_from: values.range_from,
                    range_to: values.range_to
                }))
            handleCloseModal();
        },
    })

  return (
    <div>
    <Modal isOpen={modal.isShow} toggle={handleCloseModal}>
        <ModalHeader toggle={handleCloseModal} tag={"h4"}>
            <p>Update Income Range</p>
        </ModalHeader>
        <ModalBody>

            <Form
                onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                }}>
                <FormGroup>
                    <Label for={'rangeLabelInput'}>Label :</Label>
                    <b id='rangeLabelInput' className='text-bold'>{ validation.values.range_from} - {validation.values.range_to}</b>
                    {/* <Input
                        name='lable'
                        id='rangeLabelInput'
                        placeholder="Enter Label"
                        onChange={validation.handleChange}
                        disabled={true}
                        value={`${validation.values.range_from} - ${validation.values.range_to}`}
                    /> */}
                </FormGroup>

                <FormGroup>
                    <Label for='rangeFromInput'>Range From</Label>
                    <Input
                        name='range_from'
                        type='number'
                        id='rangeFromInput'
                        placeholder="Enter Range"
                        value={validation.values.range_from}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                            validation.touched.range_from &&
                                validation.errors.range_from
                                ? true
                                : false
                        }
                    />

                    {validation.touched.range_from &&
                        validation.errors.range_from ? (
                        <FormFeedback type="invalid">
                            {validation.errors.range_from}
                        </FormFeedback>
                    ) : null}
                </FormGroup>

                <FormGroup>
                    <Label for='rangeTo'>Range TO</Label>
                    <Input
                    type='number'
                        name='range_to'
                        id='rangeTo'
                        placeholder="Enter Range"
                        value={validation.values.range_to}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                            validation.touched.range_to &&
                                validation.errors.range_to
                                ? true
                                : false
                        }
                    />

                    {validation.touched.range_to &&
                        validation.errors.range_to ? (
                        <FormFeedback type="invalid">
                            {validation.errors.range_to}
                        </FormFeedback>
                    ) : null}

                </FormGroup>

                <FormGroup>
                    <Button color='primary' type='submit'>Submit</Button>
                </FormGroup>

            </Form>



        </ModalBody>
    </Modal>
</div>
  )
}

export default UpdateIncomeRange